import { render, staticRenderFns } from "./BCXParticipateLinks.vue?vue&type=template&id=529af8f7&scoped=true"
import script from "./BCXParticipateLinks.vue?vue&type=script&lang=ts"
export * from "./BCXParticipateLinks.vue?vue&type=script&lang=ts"
import style0 from "./BCXParticipateLinks.vue?vue&type=style&index=0&id=529af8f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529af8f7",
  null
  
)

export default component.exports